// @flow

import React from 'react';

import { AppCallout } from '@zapier/design-system-app-profiles';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import appCalloutQuery from 'web-ssr/app/app-directory/components/AppCallout/appCalloutQuery';
import { createAbsoluteURL } from 'web-ssr/app/common/utils/AppUtils';

import type {
  appCalloutQuery as appCalloutQueryType,
  appCalloutQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: appCalloutQueryType,
};

type Props = {
  appSlug: string,
};

const AppCalloutContainer = (props: Props) => {
  const variables: appCalloutQueryVariables = { slug: props.appSlug };

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'small' },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'medium' },
  });

  return (
    <ApolloQuery query={appCalloutQuery} variables={variables}>
      {(result: Result) => {
        const { appBySlug } = result.data || {};

        if (!appBySlug || !appBySlug.isUpcoming) {
          return null;
        }

        const appColor = appBySlug.primaryColor
          ? '#' + appBySlug.primaryColor
          : undefined;

        return (
          <AppCallout
            appColor={appColor}
            appIconSrc={appBySlug.image || ''}
            appName={appBySlug.name}
            descriptionText={`Help your users to connect ${appBySlug.name} to the other apps they use every day.`}
            href={createAbsoluteURL('/platform')}
            linkText="Go to the Developer Platform"
            size={layoutProps.size}
          />
        );
      }}
    </ApolloQuery>
  );
};

export default AppCalloutContainer;
